const AUTOMATIONS_TAB = {
  summary: 'summary',
  analytics: 'analytics',
  recipients: 'recipients',
  giftActivity: 'gift-activity',
  thankYou: 'thankYou'
};

const AUTOMATION_CONTACTS_TAB = {
  contacts: 'contacts',
  tags: 'tags'
};

const COLLECTIONS_TAB = {
  saved: 'saved',
  featured: 'featured'
};

const CONTACTS_TAB = {
  overview: 'overview',
  recognitions: 'recognitions',
  automations: 'automations'
};

const NEW_CONTACTS_TAB = {
  individual: 'form',
  bulkImport: 'spreadSheet'
};

const RECOGNITION_CONTACTS_TAB = {
  list: 'list',
  number: 'number'
};

const RECOGNITIONS_TAB = {
  order: 'order',
  analytics: 'analytics',
  recipients: 'recipients',
  shareOptions: 'share-options',
  tyNotes: 'ty-notes'
};

const SETTINGS_TAB = {
  account: 'account',
  paymentMethods: 'payment-methods',
  branding: 'branding',
  users: 'users'
};

const WRAPPERS_TAB = {
  featured: 'featured',
  saved: 'saved'
};

export {
  AUTOMATIONS_TAB,
  AUTOMATION_CONTACTS_TAB,
  COLLECTIONS_TAB,
  CONTACTS_TAB,
  NEW_CONTACTS_TAB,
  RECOGNITIONS_TAB,
  RECOGNITION_CONTACTS_TAB,
  SETTINGS_TAB,
  WRAPPERS_TAB
};
